import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-truck-moving p-mr-2" }, null, -1)
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-col" }
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "p-grid" }
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }, null, -1)
const _hoisted_13 = { class: "p-col" }
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_17 = { class: "p-grid" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Accepted by user ")
  ])
], -1)
const _hoisted_19 = { class: "p-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Broker ")
  ])
], -1)
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Truck number ")
  ])
], -1)
const _hoisted_24 = { class: "p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SendMessageDialog = _resolveComponent("SendMessageDialog")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Fieldset, { class: "p-mb-3 relative" }, {
    legend: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('driver_summary.title')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('driver_summary.first_name')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: {
              name: _ctx.shiftRoute,
              query: { id: _ctx.ticket.user.id }
            },
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.ticket.user?.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('driver_summary.last_name')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.ticket.user?.surname), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('driver_summary.phone')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: `tel:+${_ctx.ticket.user?.phone}`
          }, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.user?.phone), 1)
          ], 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('driver_summary.email')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: `mailto:${_ctx.ticket.user?.email}`
          }, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.user?.email), 1)
          ], 8, _hoisted_15)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.ticket.accepted_by_user ? `${_ctx.ticket.accepted_by_user.fullname} - ${_ctx.$t('user.role_' + _ctx.ticket.accepted_by_user.role)}` : '-'), 1),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.ticket.broker?.business_name), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.ticket.truck_number), 1)
      ]),
      _withDirectives(_createVNode(_component_Button, {
        icon: "pi pi-send",
        style: {"position":"absolute","top":"-1rem","right":"1rem"},
        class: "p-mr-1 p-button-help",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayMessageDialog = true))
      }, null, 512), [
        [
          _directive_tooltip,
          _ctx.$t('send_message'),
          void 0,
          { bottom: true }
        ]
      ]),
      _createVNode(_component_SendMessageDialog, {
        userId: _ctx.ticket?.user_id,
        visible: _ctx.displayMessageDialog,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayMessageDialog = $event)),
        position: "right"
      }, null, 8, ["userId", "visible"])
    ]),
    _: 1
  }))
}